import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { LEGAL_CONTACT_EMAIL, LEGAL_ORG_NAME } from '../lib/legal-site-info';

export function TermsPage() {
  return (
    <>
      <Seo
        path="/voorwaarden"
        title="Algemene voorwaarden"
        description={`Algemene voorwaarden ComfortTool™ — ${LEGAL_ORG_NAME}. Indicatieve scan, prijzen, aansprakelijkheid, digitaal product.`}
        keywords="ComfortTool voorwaarden, algemene voorwaarden, gebruik, scan"
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:py-14 text-ct-text">
        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Algemene voorwaarden (concept)</h1>
        <p className="mt-2 text-sm text-ct-muted">{LEGAL_ORG_NAME}</p>
        <div className="mt-8 space-y-6 text-sm leading-relaxed text-ct-muted">
          <section>
            <h2 className="text-lg font-bold text-ct-text">1. Dienst</h2>
            <p className="mt-2">
              {LEGAL_ORG_NAME} biedt een indicatieve online scan voor warmte- en koelbelasting op basis van jouw invoer.
              Het is <strong className="text-ct-text">geen</strong> officieel energielabel,{' '}
              <strong className="text-ct-text">geen</strong> VABI/warmteverlies-vervanger en{' '}
              <strong className="text-ct-text">geen</strong> bindend installatieadvies.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">2. Indicatief karakter</h2>
            <p className="mt-2">
              Uitkomsten, grafieken en rapportteksten zijn met zorg berekend of gegenereerd, maar kunnen afwijken van
              de werkelijkheid. Je blijft zelf verantwoordelijk voor beslissingen. Raadpleeg altijd een erkende
              adviseur of installateur voor definitieve keuzes, vergunningen en subsidies.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">3. Prijzen en btw</h2>
            <p className="mt-2">
              Richtprijzen op de site zijn gebaseerd op het prijsplan (m²-band en doelgroep). Particuliere tarieven
              worden als <strong className="text-ct-text">inclusief btw</strong> getoond; zakelijke tarieven als{' '}
              <strong className="text-ct-text">exclusief btw</strong> met vermelding van btw en totaal waar van
              toepassing. Het definitieve bedrag zie je op de beveiligde betaalpagina voordat je betaalt. Voor zeer
              grote panden kan een <strong className="text-ct-text">offerte</strong> gelden in plaats van direct online
              betalen. Zie ook{' '}
              <Link to="/prijzen" className="text-ct-accent hover:underline">
                prijzen
              </Link>
              .
            </p>
            <p className="mt-2">
              Buitenlandse B2B: controleer met je accountant of <em>reverse charge</em> van toepassing is.
            </p>
            <p className="mt-2">
              Digitale producten (zoals toegang tot rapporten en downloads in je account) worden na betaling
              beschikbaar gesteld; er is geen fysieke levering.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">4. Fair use en productgrenzen</h2>
            <p className="mt-2">
              We kunnen fair-use-limieten hanteren (zoals vermeld bij de roadmap in de app) op hergeneraties van
              rapporten en omvang van invoer. Misbruik, automatisch uitlezen van onze dienst zonder toestemming of
              oneigenlijk bulkgebruik is niet toegestaan.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">5. Aansprakelijkheid</h2>
            <p className="mt-2">
              Voor zover wettelijk toegestaan sluiten wij aansprakelijkheid uit voor indirecte schade en voor fouten
              in gegenereerde inhoud. Onze aansprakelijkheid is per geval beperkt tot het bedrag dat je in de
              desbetreffende transactie aan ons betaald hebt (indien van toepassing).
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">6. Privacy, cookies en documenten</h2>
            <p className="mt-2">
              Zie{' '}
              <Link to="/privacy" className="text-ct-accent hover:underline">
                privacy
              </Link>
              ,{' '}
              <Link to="/cookies" className="text-ct-accent hover:underline">
                cookies
              </Link>
              ,{' '}
              <Link to="/disclaimer" className="text-ct-accent hover:underline">
                disclaimer
              </Link>{' '}
              en{' '}
              <Link to="/bestelvoorwaarden" className="text-ct-accent hover:underline">
                bestelvoorwaarden
              </Link>
              .
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-ct-text">7. Contact</h2>
            <p className="mt-2">
              {LEGAL_CONTACT_EMAIL ? (
                <a href={`mailto:${LEGAL_CONTACT_EMAIL}`} className="text-ct-accent hover:underline">
                  {LEGAL_CONTACT_EMAIL}
                </a>
              ) : (
                'Configureer VITE_LEGAL_CONTACT_EMAIL voor productie.'
              )}
            </p>
          </section>
          <p className="text-xs text-ct-muted/80">
            Concepttekst — laat juridisch finaliseren voordat je deze als bindend publiceert.
          </p>
        </div>
      </div>
    </>
  );
}
